import { ApolloLink } from '@apollo/client'
import { createHttpLink } from '../createHttpLink'
import { ApolloEndpoints } from '../../types'

export function createDynamicLinks({
  authToken,
  tokenFunction,
}:
  | {
      authToken?: string
      tokenFunction?: () => Promise<string | undefined>
    }
  | undefined = {}) {
  const sylveraEndpoint = createHttpLink({
    uri: process.env.NEXT_PUBLIC_SYL_GRAPHQL_URL,
    authenticateLink: true,
    authToken,
    tokenFunction,
  })

  const sylveraContentfulEndpoint = createHttpLink({
    uri: process.env.NEXT_PUBLIC_SYL_CONTENTFUL_URL,
    headers: {
      'Sylvera-version': '2021-09-01',
    },
    authenticateLink: true,
    authToken,
    tokenFunction,
  })

  const contentfulEndpoint = createHttpLink({
    uri: `https://graphql.contentful.com/content/v1/spaces/${process.env.NEXT_PUBLIC_CONTENTFUL_SPACE}/environments/${process.env.NEXT_PUBLIC_CONTENTFUL_ENV}`,
    headers: {
      authorization: `Bearer ${process.env.NEXT_PUBLIC_POLICY_TOKEN}`,
    },
  })

  const mockEndpoint = createHttpLink({
    uri: '/api/mock/graphql',
    headers: {
      authorization: `Bearer ${process.env.NEXT_PUBLIC_POLICY_TOKEN}`,
    },
  })

  return ApolloLink.split(
    (operation) => operation.getContext().endpoint === ApolloEndpoints.mock,
    mockEndpoint,
    ApolloLink.split(
      (operation) =>
        operation.getContext().endpoint === ApolloEndpoints.sylveraContentful,
      sylveraContentfulEndpoint,
      ApolloLink.split(
        (operation) =>
          operation.getContext().endpoint === ApolloEndpoints.contentful,
        contentfulEndpoint,
        sylveraEndpoint,
      ),
    ),
  )
}
